import React from 'react';

interface ErrorBoxProps {
  error?: string;
  onClick?: () => void;
}

export default function ErrorBox({ error, onClick }: ErrorBoxProps) {
  if (!error) return null;

  return (
    <div className={`mb-2 text-center ${onClick ? 'cursor-pointer' : ''}`} onClick={e => (onClick ? onClick() : null)}>
      <p className='rounded-sm border-2 border-red-400 bg-red-100 py-1 text-sm text-red-500'>{error}</p>
    </div>
  );
}
